const modalWindowTypes = {
  EDIT: 'EDIT',
  ADD: 'ADD',
  DRAG: 'DRAG',
  CREATE: 'CREATE'
}

export default modalWindowTypes



// WEBPACK FOOTER //
// ./src/utils/dictionaries/modalWindowTypes.js